module.exports = __webpack_public_path__ + "img/12.2372ea72.png";